'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UserFactory = function UserFactory() {
  var user = {
    codingOperationsTeam: '',
    name: '',
    email: '',
    specialty: '',
    role: '',
    worklist: '',
    id: '',
    token: '',
    roleId: '',
    initialLogin: '',
    activeDirectoryToken: '',
    campus: ''
  };

  var setUser = function setUser(codingOperationsTeam, name, email, specialty, role, worklist, id, token, roleId, activeDirectoryToken, initialLogin, campus) {
    user.codingOperationsTeam = codingOperationsTeam, user.name = name;
    user.email = email;
    user.specialty = specialty;
    user.role = role;
    user.worklist = worklist;
    user.id = id;
    user.token = token;
    user.roleId = roleId;
    user.activeDirectoryToken = activeDirectoryToken;
    user.initialLogin = initialLogin;
    user.campus = campus;
  };

  var getUser = function getUser() {
    return user;
  };

  var isSignedIn = function isSignedIn() {
    return user.isSignedIn;
  };

  return { getUser: getUser, isSignedIn: isSignedIn, setUser: setUser };
};

exports.default = UserFactory;


// WEBPACK FOOTER //
// ./client/app/common/user/user.factory.js